import { FINISHED_STATES } from '../consts';

export default {
  created() {
    this.SOLD = FINISHED_STATES.SOLD;
    this.SOLD_CONDITIONALLY = FINISHED_STATES.SOLD_CONDITIONALLY;
    this.UNSOLD = FINISHED_STATES.UNSOLD;
  },
  computed: {
    sold() {
      return this.auction.state === this.SOLD;
    },
    soldConditionally() {
      return this.auction.state === this.SOLD_CONDITIONALLY;
    },
    unsold() {
      return this.auction.state === this.UNSOLD;
    },
  },
};



// WEBPACK FOOTER //
// ./app/javascript/packs/shared/mixins/compute_artwork_state.js